module.exports = __webpack_public_path__ + "static/pittsburgh-156ab37e67c9971887d418d487417126.png";